import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const rows = [{
  label: 'Preparación semanal',
  sin: '2–3 hs buscando en internet',
  con: '10 min abriendo el kit'
}, {
  label: 'Variedad de recursos',
  sin: 'Siempre lo mismo (colorear + rezar)',
  con: '+100 actividades listas'
}, {
  label: 'Participación del grupo',
  sin: 'Niños distraídos o aburridos',
  con: 'Dinámicas que generan atención real'
}, {
  label: 'Imprevistos',
  sin: 'Pánico cuando algo falla',
  con: 'Kit de Emergencia en 5 min'
}, {
  label: 'Reflexión y diálogo',
  sin: 'Monólogos sin participación',
  con: '50 preguntas disparadoras listas'
}, {
  label: 'Planificación anual (PRO)',
  sin: 'Sin estructura, sin objetivos',
  con: '10 encuentros completos listos'
}, {
  label: 'Conexión espiritual',
  sin: 'Los niños no recuerdan nada',
  con: 'Encuentros memorables y significativos'
}];
export function ComparisonTable() {
  return <section className="py-10 md:py-20 px-4 md:px-6 bg-cream-100" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-8 md:mb-12" data-id="element-19">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy-900 mb-2 md:mb-4" data-id="element-20">
            ¿Cuánto cuesta NO tenerlo?
          </h2>
          <div className="w-16 md:w-24 h-1 bg-gold-500 mx-auto mt-4 md:mt-6 rounded-full" data-id="element-21"></div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-lg border border-cream-200 overflow-hidden" data-id="element-22">
          <div className="overflow-x-auto" data-id="element-23">
            <table className="w-full text-left border-collapse min-w-[500px] md:min-w-[600px]" data-id="element-24">
              <thead data-id="element-25">
                <tr data-id="element-26">
                  <th className="p-4 md:p-6 border-b border-cream-200 bg-cream-50 w-1/3" data-id="element-27">
                    <span className="font-serif font-bold text-navy-900 text-base md:text-xl" data-id="element-28">
                      Situación
                    </span>
                  </th>
                  <th className="p-4 md:p-6 border-b border-cream-200 bg-red-50/50 w-1/3" data-id="element-29">
                    <span className="font-bold text-red-800/70 text-sm md:text-lg" data-id="element-30">
                      Sin el MegaKit
                    </span>
                  </th>
                  <th className="p-4 md:p-6 border-b border-cream-200 bg-navy-950 w-1/3" data-id="element-31">
                    <span className="font-bold text-gold-500 text-sm md:text-lg flex items-center gap-1 md:gap-2" data-id="element-32">
                      <Check className="w-4 h-4 md:w-5 md:h-5" data-id="element-33" /> Con el MegaKit
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-34">
                {rows.map((row, i) => <tr key={i} className="group hover:bg-cream-50/50 transition-colors" data-id="element-35">
                    <td className="p-4 md:p-6 border-b border-cream-200 font-medium text-navy-900 text-sm md:text-base" data-id="element-36">
                      {row.label}
                    </td>
                    <td className="p-4 md:p-6 border-b border-cream-200 text-red-800/70 text-sm md:text-base" data-id="element-37">
                      <div className="flex items-start gap-1.5 md:gap-2" data-id="element-38">
                        <X className="w-4 h-4 md:w-5 md:h-5 shrink-0 mt-0.5 opacity-50" data-id="element-39" />
                        <span data-id="element-40">{row.sin}</span>
                      </div>
                    </td>
                    <td className="p-4 md:p-6 border-b border-cream-200 bg-navy-950/5 group-hover:bg-navy-950/10 transition-colors text-sm md:text-base" data-id="element-41">
                      <div className="flex items-start gap-1.5 md:gap-2 text-navy-900 font-medium" data-id="element-42">
                        <Check className="w-4 h-4 md:w-5 md:h-5 shrink-0 mt-0.5 text-gold-600" data-id="element-43" />
                        <span data-id="element-44">{row.con}</span>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>
      </div>
    </section>;
}